import { RichTextBlock } from "@components/rich-text-block"
import IconChevronRight from "@components/ui/icons/IconChevronRight"
import { Text } from "@components/ui/typograhpy/Text"
import { cn } from "@lib/cn"
import {
  CollapsibleContent,
  CollapsibleTrigger,
  Root,
} from "@radix-ui/react-collapsible"
import { FaqQuestion as FaqQuestionModel } from "__generated__/sanity"
import React, { FC } from "react"

type FaqQuestionProps = FaqQuestionModel

export const FaqQuestion: FC<FaqQuestionProps> = ({ question, answer }) => {
  return (
    <Root className="group mb-2 max-w-100">
      <CollapsibleTrigger
        className="group/trigger grid grid-cols-[1rem_1fr] items-start gap-2 text-left text-white"
        type="button"
      >
        <IconChevronRight
          size={16}
          data-icon-chevron
          className={cn(
            'group-data-[state="open"]:rotate-90 group-data-[state="open"]:text-white',
            "group-hover/trigger:text-white",
            "mt-0.5 text-shade-400 transition-all duration-150",
          )}
        />
        <Text variant="regular">{question}</Text>
      </CollapsibleTrigger>
      <CollapsibleContent
        className={cn(
          "h-full w-full pl-6",
          "data-[state=open]:animate-open-collapsible data-[state=open]:opacity-0",
          "data-[state=closed]:animate-close-collapsible data-[state=closed]:opacity-0 data-[state=closed]:animation-duration-100",
        )}
      >
        <RichTextBlock content={answer} className="mb-4 pt-2 text-shade-400" />
        <Text variant="regular" className="text-shade-400"></Text>
      </CollapsibleContent>
    </Root>
  )
}
